<div class="container-fluid">
    <app-page-header header="{{pageTitle}}" description="{{pageSubTitle}}">
    </app-page-header>

    <!-- Tabs inside col-md-6 -->
    <div class="full-width col-md-12 col-sm-12 col-xs-12 mt-2">
        <div class="app-list">
            <mat-tab-group #tabGroup>
                <mat-tab label="Services">
                  <app-services-list></app-services-list>
                </mat-tab>
                <mat-tab label="Environments">
                  <app-environment-list></app-environment-list>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
